module.exports = function UpdateSourceRegistrationRequest(cid, path) {
    this.cid = cid;
    this.path = path;
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/topic-update/update-source-registration-request.js
// module id = 735
// module chunks = 1